
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { DataLoaderService } from './data-loader.service';
import { PriceCalculationService } from './price-calculation.service';
import { CommonDataService } from "../services/common-data.service";
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { VehicleInfoService } from './vehicle-info.service';
import * as CryptoJS from 'crypto-js';
import { TokenEncrption } from './encryption-File.service';

@Injectable()
export class AlternateOptionsService {
	public headerOptions:any;
	public requestOptions:any;
	public suggestionData: any;
	public dataVersion: String;
	public data: any;
	public collectArray = [];
	public collectArrayRemove = [];
	public expertAddedCodes = [];
	public alternateFlag: boolean;
	public url = this.dataLoaderService.baseUrl;
	public path = this.dataLoaderService.path;
	public subscription: Subscription;
	public lang: any;
	public configurationId :String;
	public configFlag:boolean = false
	public intialExpertColor:any
	public configurationIdIndex:any
	public addedColor:any
	vehicleInfo: { hookURL: string; urlFlag: string; language: string; configurationDate: string; orderingMarket: string; pricingDate: string; salesLevel: string; taxDate: string; materialType: string; plant: string; baumuster: string; internalVehicleId: string; savedConfig: string; productionDate: string; vehicleDescription: string; vehicleClass: string; preSeriesModeFlag: string; driveType: string; materialGroupExt: string; requestedProductionDate: string; authToken: string; };
	encryptedToken: any;

	constructor(private http: Http, private dataLoaderService: DataLoaderService,
		private priceCalculationService: PriceCalculationService, private commonDataService: CommonDataService, private vehicleInfoService: VehicleInfoService, private tokenEncrption:TokenEncrption) {
			this.vehicleInfo = this.vehicleInfoService.extractData();
			this.encryptedToken =   tokenEncrption.getencryptedToken();
		// this.headers.append('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
		// this.headers.append('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
		this.subscription = this.commonDataService.notifyObservableLanguage$.subscribe((lang) => {
			this.lang = lang.data;
		});

		let x = window.location.search.replace(/\+/g, '%20');
        let uricomponents = decodeURIComponent(x).substring(1).split('&');
        for (let i = 0; i < uricomponents.length; i++) {
            let pair = uricomponents[i].split('=');
            if (pair[0] === 'authToken'){
                let accesstokenkey = pair[1];
         this.headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            // 'Authorization-Token': accesstokenkey,
			'Authorization-Token': this.encryptedToken,
			'parturl': this.dataLoaderService.parturl,

        }
         this.requestOptions = { 
            headers: new Headers(this.headerOptions)
        };
	}
		}	
		if(this.requestOptions==undefined){
			const headerOptions = {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Authorization-Token': this.encryptedToken,
			}
			 this.requestOptions = {
				headers: new Headers(headerOptions)
			};

		}
	}

	getDataVersion() {
		if (this.dataLoaderService.vehicleInfo.dataVersion === undefined) {
			return '';
		} else {
			return this.dataLoaderService.vehicleInfo.dataVersion;
		}
	}

	public getAlternateOptionsExpert() {
		const headers = new Headers();
		headers.append('Content-Type', "application/json; charset=utf-8");
		headers.append('Access-Control-Allow-Methods', 'POST');
		headers.append('Authorization-Token','Bearer 04dd4eca-7cb7-4614-b865-fd858a8e483f')
		let arr = [];
		let updateResponse;
		let suggestionConfig: string;
		let vehicleInformation = this.dataLoaderService.vehicleInfo;
		let expertAdded = [];
		let otherOptionCodesExp = [];
		let otherOptionCodesExpRem = [];
		let cntAdded = 0;
		let cntRemoved = 0;
		const hiddenOptions: Array<string> = this.dataLoaderService.hiddenOptions;
		// if (false) {
		// 	suggestionConfig = this.dataLoaderService.previousData
		// }
		// else {
			this.dataLoaderService.expertAddedCodes = []
			if (this.dataLoaderService.expAddedOnClose.length > 0) {
				this.dataLoaderService.expertAddedCodes = this.dataLoaderService.expAddedOnClose;

			}

			if (this.dataLoaderService.expRemovedOnClose.length > 0) {
				this.dataLoaderService.expertRemovedCodes = this.dataLoaderService.expRemovedOnClose;

			}
			this.dataVersion = this.getDataVersion();
			this.collectArray = this.priceCalculationService.mergingAllExpert();
			this.collectArrayRemove = this.priceCalculationService.mergingAllExpertForRemoved();
			
			for (let index in this.collectArray) {
				if (this.collectArray[index] != undefined) {
					otherOptionCodesExp.push(this.collectArray[index]);
				}
			}
			for (let index in this.collectArrayRemove) {
				if (this.collectArrayRemove[index] != undefined)
					otherOptionCodesExpRem.push(this.collectArrayRemove[index]);
			}
			if (this.dataLoaderService.flagDictionary.expertValidateFlag) {
				
				this.expertAddedCodes = this.priceCalculationService.mergeExpertAddedCodes();
				for (let index in this.expertAddedCodes) {
					if (this.expertAddedCodes[index] != undefined) {
						expertAdded.push(this.expertAddedCodes[index]);
					}
				}

				for (let j in expertAdded) {
					for (let i in this.dataLoaderService.expAdd) {
						if (this.dataLoaderService.expAdd[i] === expertAdded[j].code) {
							cntAdded++;
						}
					}
					if (cntAdded > 0) {
						this.dataLoaderService.expertAddedCodes.push(expertAdded[j]);
						cntAdded = 0;
					}
				}

			}

			this.dataLoaderService.expAdd = [];
			this.dataLoaderService.expAddedOnClose = [];
			this.dataLoaderService.expRemovedOnClose = [];


			let language;
			if (this.lang === undefined) {
				language = this.dataLoaderService.vehicleInfo.language;

			}
			else {
				language = this.lang;
			}
			if(this.configurationId===undefined){

				this.configurationId = '1234';
	
			} 
			if(vehicleInformation.urlFlag == '1'){
				if( this.configFlag == true){
					this.configurationId = this.configurationId
					// console.log(this.configurationId)
				}
				else {
					this.configurationId = this.dataLoaderService.configurationId
					// console.log(this.configurationId)
				}
			}
			if (this.dataLoaderService.vehicleInfo.orderingMarket in {901: null, 919: null, 847: null, 817: null, 601: null, 675: null, 839: null, 701: null, 771: null, 581: null, 737: null, } && (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1')){        
                if(this.dataLoaderService.expertAddedCodes.length==0){
                    if(this.dataLoaderService.expertRemovedCodes.length == 0){
                        this.dataLoaderService.expertAddedCodes[0] = this.intialExpertColor
                        // console.log()
                    }
                }
            }
            if (Array.isArray(this.configurationId)) {
                this.configurationId = this.configurationId[0]
            }
			// console.log(this.dataLoaderService.expertAddedCodes)

			if (this.dataLoaderService.expertRemovedCodes.length === 0) {
				// fix for-removed codes were missed from otherOptionCodesExp
				// for (let i in this.dataLoaderService.expertRemovedCodes) {
				// 	otherOptionCodesExp.push(this.dataLoaderService.expertRemovedCodes[i]);
				// }

				suggestionConfig = '{\"language\":\"' + language.toUpperCase()
					+ '\", \"configurationDate\":\"' + vehicleInformation.productionDate
					+ '\", \"orderingMarket\":\"' + vehicleInformation.orderingMarket
					+ '\", \"pricingDate\":\"' + vehicleInformation.pricingDate
					+ '\", \"salesLevel\":\"' + vehicleInformation.salesLevel
					+ '\", \"taxDate\":\"' + vehicleInformation.taxDate
					+ '\", \"baumuster\":\"' + vehicleInformation.baumuster
					+ '\", \"addedCodes\":' + JSON.stringify(this.dataLoaderService.expertAddedCodes)
					+ ',\"removeCodes\":' + JSON.stringify(this.dataLoaderService.expertRemovedCodes)
					+ ',\"dataversion\":\"' + this.dataVersion
					+ '\",\"selectedEquipments\":' + JSON.stringify(otherOptionCodesExp)
					+ ',\"hiddenOptions\":' + JSON.stringify(hiddenOptions)
					+ ',\"configurationId\":' + JSON.stringify(this.configurationId)
					+ '}';
			}
			else {
				// fix for-removed codes were missed from otherOptionCodesExp
				// for (let i in this.dataLoaderService.expertRemovedCodes) {
				// 	otherOptionCodesExp.push(this.dataLoaderService.expertRemovedCodes[i]);
				// }

				suggestionConfig = '{\"language\":\"' + language.toUpperCase()
					+ '\", \"configurationDate\":\"' + vehicleInformation.productionDate
					+ '\", \"orderingMarket\":\"' + vehicleInformation.orderingMarket
					+ '\", \"pricingDate\":\"' + vehicleInformation.pricingDate
					+ '\", \"salesLevel\":\"' + vehicleInformation.salesLevel
					+ '\", \"taxDate\":\"' + vehicleInformation.taxDate
					+ '\", \"baumuster\":\"' + vehicleInformation.baumuster
					+ '\", \"addedCodes\":' + JSON.stringify(this.dataLoaderService.expertAddedCodes)
					+ ',\"removeCodes\":' + JSON.stringify(this.dataLoaderService.expertRemovedCodes)
					+ ',\"dataversion\":\"' + this.dataVersion
					+ '\",\"selectedEquipments\":' + JSON.stringify(otherOptionCodesExp)
					+ ',\"hiddenOptions\":' + JSON.stringify(hiddenOptions)
					+ ',\"configurationId\":' + JSON.stringify(this.configurationId)
					+ '}';
			}

			suggestionConfig = JSON.parse(suggestionConfig);

			this.dataLoaderService.previousData = suggestionConfig;
			this.dataLoaderService.expertRemovedCodes = []
		// }
		return this.http.post(this.url + this.path + 'new/analysis', suggestionConfig, this.requestOptions)
			.map((response) => {
				this.dataLoaderService.flagDictionary.loadingFlag = false;
				let data = response.json();
				if (data) {
					updateResponse = data
				}
				if (this.dataLoaderService.vehicleInfo.orderingMarket in {901: null, 919: null, 847: null, 817: null, 601: null, 675: null, 839: null, 701: null, 771: null, 581: null, 737: null, } && (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1')){        
					if(updateResponse.configurationId.length>1){
						this.configurationId = updateResponse.configurationId
					}
					else {
						this.configurationId = updateResponse.configurationId[0]
					}
					this.configFlag = true
					this.addedColor = updateResponse.suggestions[0].addedCodes[0]   
				  }
				if (Array.isArray(this.configurationId)) {
					this.configurationId = this.configurationId[0]
				}
				
				
				this.dataLoaderService.gccPreviousHiddenOptions = this.dataLoaderService.hiddenOptions;
				this.dataLoaderService.gccUpdatedPrices = updateResponse.suggestions[0].updatedPrices;
				this.dataLoaderService.gccInternalCodes = updateResponse.suggestions[0].internalCodes;
				this.dataLoaderService.hiddenOptions = updateResponse.suggestions[0].hiddenOptionsCodes;
				return (updateResponse);
			},
				(err) => {
					;
					if (err.status === 500) {
						if (JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = err._body;
						} else if (!JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = JSON.parse(err._body);
							if (this.dataLoaderService.errorMessage == "") {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
						}
					} else if (err.status === 404) {
						if (JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = err._body;
						} else if (!JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = JSON.parse(err._body);
							if (this.dataLoaderService.errorMessage == "") {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
						}
					} else {
						if (JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = err._body;
						} else if (!JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = JSON.parse(err._body);
							if (this.dataLoaderService.errorMessage == "") {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
						}
					}
					// this.dataLoaderService.flagDictionary.loadingFlag = false;
					this.dataLoaderService.flagDictionary.exceptionFlag = true;
				}
			);
	}

	public getAlternateOptionsNormal(item: any) {
		
		this.dataVersion = this.getDataVersion();
		let updateResponse;
		let suggestionConfig: string;
		let suggestionConfig1: any;
		let otherOptionCodes = [];
		const hiddenOptions: Array<string> = this.dataLoaderService.hiddenOptions;
		this.collectArray = this.priceCalculationService.mergingAllNormal();
		
		for (let index in this.collectArray) {
			
			if (this.collectArray[index] != undefined)
				otherOptionCodes.push(this.collectArray[index]);
				
		}
		let temp = otherOptionCodes.map(a=>a.code);
		let vehicleInformation = this.dataLoaderService.vehicleInfo;

		let language;

		if (this.lang === undefined) {
			language = this.dataLoaderService.vehicleInfo.language;
			//language = "en";
		}
		else {
			language = this.lang;
		}
		if(this.configurationId===undefined){

            this.configurationId = '1234';

        }
		if(vehicleInformation.urlFlag == '1'){
			if( this.configFlag == true){
				this.configurationId = this.configurationId
				// console.log(this.configurationId)
			}
			else {
				this.configurationId = this.dataLoaderService.configurationId
				// console.log(this.configurationId)
			}
		}
		if (Array.isArray(this.configurationId)) {
			this.configurationId = this.configurationId[0]
		}
		if (!item.selected) {
			suggestionConfig = '{\"language\":\"' + language.toUpperCase()
				+ '\", \"configurationDate\":\"' + vehicleInformation.productionDate
				+ '\", \"orderingMarket\":\"' + vehicleInformation.orderingMarket
				+ '\", \"pricingDate\":\"' + vehicleInformation.pricingDate
				+ '\", \"salesLevel\":\"' + vehicleInformation.salesLevel
				+ '\", \"taxDate\":\"' + vehicleInformation.taxDate
				+ '\", \"baumuster\":\"' + vehicleInformation.baumuster
				+ '\", \"addedCodes\":[' + JSON.stringify(item) + '],\"removeCodes\":[]'
				+ ',\"dataversion\":\"' + this.dataVersion
				+ '\",\"selectedEquipments\":' + JSON.stringify(otherOptionCodes)
				+ ',\"hiddenOptions\":' + JSON.stringify(hiddenOptions)
				+ ',\"configurationId\":' + JSON.stringify(this.configurationId)
				+ '}';
		} else {
			suggestionConfig = '{\"language\":\"' + language.toUpperCase()
				+ '\", \"configurationDate\":\"' + vehicleInformation.productionDate
				+ '\", \"orderingMarket\":\"' + vehicleInformation.orderingMarket
				+ '\", \"pricingDate\":\"' + vehicleInformation.pricingDate
				+ '\", \"salesLevel\":\"' + vehicleInformation.salesLevel
				+ '\", \"taxDate\":\"' + vehicleInformation.taxDate
				+ '\", \"baumuster\":\"' + vehicleInformation.baumuster
				+ '\", \"addedCodes\":[],\"removeCodes\":[' + JSON.stringify(item) + ']'
				+ ',\"dataversion\":\"' + this.dataVersion
				+ '\",\"selectedEquipments\":' + JSON.stringify(otherOptionCodes)
				+ ',\"hiddenOptions\":' + JSON.stringify(hiddenOptions)
				+ ',\"configurationId\":' + JSON.stringify(this.configurationId)
				+ '}';
		}
		suggestionConfig1 = JSON.parse(suggestionConfig);
		if (this.dataLoaderService.flagDictionary.loadingFlag) {
			return this.http.post(this.url + this.path + 'new/analysis', suggestionConfig1, this.requestOptions)
				.map((response) => {
					this.dataLoaderService.flagDictionary.loadingFlag = false;
					let data = response.json();
					if (data) {
						updateResponse = data
					}
					this.configurationId =  updateResponse.configurationId;
					this.addedColor = updateResponse.suggestions[0].addedCodes[0]
					console.log(this.configurationId)
					this.configFlag = true
					this.dataLoaderService.gccPreviousHiddenOptions = this.dataLoaderService.hiddenOptions;
					this.dataLoaderService.gccInternalCodesAccept = updateResponse.suggestions[0].internalCodes;
					this.dataLoaderService.gccUpdatedPrices = updateResponse.suggestions[0].updatedPrices;
					this.dataLoaderService.hiddenOptions = updateResponse.suggestions[0].hiddenOptionsCodes;
					return (updateResponse);
				},
					(err) => {
						if (err.status === 500) {
							if (JSON.stringify(err._body).includes('details')) {
								this.dataLoaderService.errorMessage = err._body;
							} else if (!JSON.stringify(err._body).includes('details')) {
								this.dataLoaderService.errorMessage = JSON.parse(err._body);
								if (this.dataLoaderService.errorMessage == "") {
									this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
								}
							} else {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else if (err.status === 404) {
							if (JSON.stringify(err._body).includes('details')) {
								this.dataLoaderService.errorMessage = err._body;
							} else if (!JSON.stringify(err._body).includes('details')) {
								this.dataLoaderService.errorMessage = JSON.parse(err._body);
								if (this.dataLoaderService.errorMessage == "") {
									this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
								}
							} else {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							if (JSON.stringify(err._body).includes('details')) {
								this.dataLoaderService.errorMessage = err._body;
							} else if (!JSON.stringify(err._body).includes('details')) {
								this.dataLoaderService.errorMessage = JSON.parse(err._body);
								if (this.dataLoaderService.errorMessage == "") {
									this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
								}
							} else {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						}
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.dataLoaderService.flagDictionary.exceptionFlag = true;
					}
				);
		}
	}

	//Updated Prices from alternate validation response
	public getUpdatedPriceForAlternates(selectedAlternate: any,configurationIdIndex) {
		// Index of configuration Id of Selected Suggestion
		this.configurationIdIndex = configurationIdIndex
		// console.log(selectedAlternate)
		this.dataVersion = this.getDataVersion();
		let updateResponse;
		let alternateConfig: string;
		let alternateConfig1: any;
		let vehicleInformation = this.dataLoaderService.vehicleInfo;

		let language;
		if (this.lang === undefined) {
			language = this.dataLoaderService.vehicleInfo.language;
			//language = "en";
		}
		else {
			language = this.lang;
		}
		alternateConfig = '{\"language\":\"' + language.toUpperCase()
			+ '\", \"configurationDate\":\"' + vehicleInformation.productionDate
			+ '\", \"orderingMarket\":\"' + vehicleInformation.orderingMarket
			+ '\", \"pricingDate\":\"' + vehicleInformation.pricingDate
			+ '\", \"salesLevel\":\"' + vehicleInformation.salesLevel
			+ '\", \"taxDate\":\"' + vehicleInformation.taxDate
			+ '\", \"baumuster\":\"' + vehicleInformation.baumuster
			+ '\", \"dataversion\":\"' + this.dataVersion
			+ '\", \"selectedEquipments\":[]'
			+ ',\"addedCodes\":' + JSON.stringify(selectedAlternate.addedCodes)
			+ ',\"removeCodes\":' + JSON.stringify(selectedAlternate.removedCodes)
			+ ',\"computeDecisionTreeConfigurationCodes\":' + JSON.stringify(selectedAlternate.computeDecisionTreeConfigurationCodes)
			+ ',\"configurationId\":' + JSON.stringify(this.configurationId)
			+ '}';

		alternateConfig1 = JSON.parse(alternateConfig);

		this.dataLoaderService.flagDictionary.loadingFlag = true;
		return this.http.post(this.url + this.path + 'price/analysis', alternateConfig1, this.requestOptions)
			.map((response) => {
				this.dataLoaderService.flagDictionary.loadingFlag = false;
				let data = response.json();
				if (data) {
					updateResponse = data;
				}
				return (updateResponse);
			},
				(err) => {
					if (err.status === 500) {
						if (JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = err._body;
						} else if (!JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = JSON.parse(err._body);
							if (this.dataLoaderService.errorMessage == "") {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
						}
					} else if (err.status === 404) {
						if (JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = err._body;
						} else if (!JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = JSON.parse(err._body);
							if (this.dataLoaderService.errorMessage == "") {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
						}
					} else {
						if (JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = err._body;
						} else if (!JSON.stringify(err._body).includes('details')) {
							this.dataLoaderService.errorMessage = JSON.parse(err._body);
							if (this.dataLoaderService.errorMessage == "") {
								this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
							}
						} else {
							this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
						}
					}
					this.dataLoaderService.flagDictionary.loadingFlag = false;
					this.dataLoaderService.flagDictionary.exceptionFlag = true;
				}
			);
	}
}




// WEBPACK FOOTER //
// ./src/app/services/alternate-options.service.ts